import { render, staticRenderFns } from "./HrEmployeeLoanCompanyCreate.vue?vue&type=template&id=243bf4f4&lang=pug&"
import script from "./HrEmployeeLoanCompanyCreate.vue?vue&type=script&lang=js&"
export * from "./HrEmployeeLoanCompanyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HrEmployeeLoanCompanyCreate.vue"
export default component.exports